import request from 'local_modules/request'
import moment from 'moment'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'

const setFetching = (isFetching) => reducers.news.setFetching(isFetching)

const fetchNews = () => {
  const { me: { id } } = getState()

  return request.get(constants.news.list)
    .then(({ data }) => data)
    .then((data) => {
      let _data = data

      if (_data && _data.length) {
        _data = _data.map(({ header, body, created, author_id, image, ...rest }) => ({
          title: header,
          description: body,
          date: moment(created).format('DD.MM.YYYY'),
          time: moment(created).format('HH:mm'),
          canEdit: author_id === id,
          image: `${constants.news.img}?id=${image}`,
          ...rest,
        }))
      }

      reducers.news.setNews(_data)
    })
    .catch((error) => console.error(error))
}

const addNews = ({ title: header, description: body, image, source, sourceLink }) => {
  console.log('add', {
    header,
    body,
    image,
    source,
    sourceLink,
  })

  return request.post(constants.news.add, {
    header,
    body,
    image,
    source,
    sourceLink,
  })
    .then(({ data }) => data)
    .catch((error) => console.error(error))
}

const editNews = ({ id, title: header, description: body, image, source, sourceLink }) => {
  const isSameImage = image.includes(`${constants.news.img}?id=`)

  console.log('edit', {
    id,
    header,
    body,
    image: isSameImage ? null : image,
    source,
    sourceLink,
  })

  return request.put(constants.news.update, {
    id,
    header,
    body,
    image: isSameImage ? null : image,
    source,
    sourceLink,
  })
    .then(({ data }) => data)
    .catch((error) => console.error(error))
}

const deleteNews = (id) => {
  return request.delete(constants.news.delete + `/${id}`)
    .then(({ data }) => data)
    .catch((error) => console.error(error))
}


export default {
  setFetching,

  fetchNews,
  addNews,
  editNews,
  deleteNews,
}
